import React from "react";
import "../styles/Dashboard.css";

const ToolCard = ({ title, subtitle, icon: Icon, onClick }) => {
  return (
    <div className="tool-card" onClick={onClick}>
      {Icon && <Icon className="tool-icon" />}
      <h3>{title}</h3>
      <p>{subtitle}</p>
    </div>
  );
};

export default ToolCard;
